module.exports = __webpack_public_path__ + "assets/chevron-left.7b492c22.svg";